export enum AUDIT_LOG_MODEL_NAME {
  ENTITY = "EntityEntity",
  ENTIY_INDIVIDUAL = "EntityIndividual",
}
